export const environment = {
  environment: 'development',
  // Keycloak
  keycloakUrl: 'https://auth.test123.nl',
  keycloakRealm: 'wander-and-wonder',
  keycloakClientId: 'stichting-wijkcollectie',
  // API
  apiUrl: 'https://wvk-cms-api.test123.nl',
  // apiUrl: 'http://hwvdk-cms-api.docker:8080'
  // apiUrl: 'https://api-cms.wijkcollectie.nl'
};
